import { AppRoutes } from 'utilitys/appRoutes/AppRoutes';

import { executionConfig } from 'components/Dashboards/Project/ProjectWrapper/executionConfig';

const CARD_TYPES = {
    itemRecommendation: 'KC_INSIGHT',
    itemProgramActivities: 'PROGRAMME_ACTIVITY',
    itemUserActivities: 'USER_GENERATED',
};

export const BATTLECARDS_FILTERS = {
    7: ['URGENT_7_DAYS', 'NOT_URGENT_7_DAYS'],
    14: ['URGENT_14_DAYS', 'NOT_URGENT_14_DAYST'],
    30: ['URGENT_30_DAYS', 'NOT_URGENT_30_DAYS'],
    90: ['URGENT_90_DAYS', 'NOT_URGENT_90_DAYST'],
};
export const MATRIX_COMPONENTS = {
    doNowComponent: {
        urgent: true,
        important: true,
    },
    doNextComponent: {
        urgent: false,
        important: true,
    },
    prioritizeComponent: {
        urgent: true,
        important: false,
    },
    laterComponent: {
        urgent: false,
        important: false,
    },
};

export const PRIORITIES_MATRIX_COMPONENT_HEIGHT = '743px';
export const PRIORITIES_MATRIX_FILTERS: ISelectOption<string>[] = [
    {
        label: '7D',
        value: '7',
    },
    {
        label: '14D',
        value: '14',
    },
    {
        label: '30D',
        value: '30',
    },
    {
        label: '3M',
        value: '90',
    },
];

export const initialMatrixFilter = '30';

const getIsOverdueAndIsDelayDriverFilter = ({ isDelayDriverFilter, isOverdueFilter, isCriticalPathFilter }) => {
    if (isDelayDriverFilter && isOverdueFilter && isCriticalPathFilter) {
        return 'DELAY_DRIVER_CARD_BOARD,OVERDUE_CARD_BOARD,CRITICAL_PATH_USER_CARD_BOARD';
    } else if (isDelayDriverFilter && isOverdueFilter) {
        return 'DELAY_DRIVER_CARD_BOARD,OVERDUE_CARD_BOARD';
    } else if (isDelayDriverFilter && isCriticalPathFilter) {
        return 'DELAY_DRIVER_CARD_BOARD,CRITICAL_PATH_USER_CARD_BOARD';
    } else if (isOverdueFilter && isCriticalPathFilter) {
        return 'OVERDUE_CARD_BOARD,CRITICAL_PATH_USER_CARD_BOARD';
    } else if (isDelayDriverFilter) {
        return 'DELAY_DRIVER_CARD_BOARD';
    } else if (isOverdueFilter) {
        return 'OVERDUE_CARD_BOARD';
    } else if (isCriticalPathFilter) {
        return 'CRITICAL_PATH_USER_CARD_BOARD';
    }

    return null;
};

export const getLinkToBattlecards = ({ ui, getAssignedToMeQueryFilter }) => {
    const isUrgent = MATRIX_COMPONENTS[ui.state.selectedTypeAndRole.type].urgent;
    const important = MATRIX_COMPONENTS[ui.state.selectedTypeAndRole.type].important ? 'IMPORTANT' : 'NOT_IMPORTANT';
    const filterData = ui.state.numOfDaysToBeUrgent;
    const urgent = filterData && (isUrgent ? BATTLECARDS_FILTERS[filterData][0] : BATTLECARDS_FILTERS[filterData][1]);
    const riskIndicators = getIsOverdueAndIsDelayDriverFilter({
        isDelayDriverFilter: ui.state.isDelayDriverFilter,
        isOverdueFilter: ui.state.isOverdueFilter,
        isCriticalPathFilter: ui.state.isCriticalPathFilter,
    });

    const activityCode = Array.isArray(ui.flatPills.activityCodes)
        ? ui.flatPills.activityCodes.map((activityCode) => ({ name: activityCode, isExclude: false }))
        : [];
    const activityCodeExclude = Array.isArray(ui.flatPills.activityCodesExclude)
        ? ui.flatPills.activityCodesExclude.map((activityCode) => ({
              name: activityCode,
              isExclude: true,
          }))
        : [];

    const tags = Array.isArray(ui.flatPills.tags)
        ? ui.flatPills.tags.map((tag) => ({ name: tag, isExclude: false }))
        : [];
    const tagsExclude = Array.isArray(ui.flatPills.tagsExclude)
        ? ui.flatPills.tagsExclude.map((tag) => ({
              name: tag,
              isExclude: true,
          }))
        : [];

    const isAssignedToMe = getAssignedToMeQueryFilter();
    const wbsQuery = ui.state.wbs;

    const query = {
        important: important,
        urgent: urgent,
        cardType: CARD_TYPES[ui.state.selectedTypeAndRole.role] ? [CARD_TYPES[ui.state.selectedTypeAndRole.role]] : '',
        riskIndicators: riskIndicators?.split(','),
        assignee: isAssignedToMe,
        activityCodes: [...activityCode, ...activityCodeExclude],
        tags: [...tags, ...tagsExclude],
        wbs: wbsQuery,
        activityFragnet: ui.state.milestoneFragnet,
    };
    const id = ui.state.versionId;
    return AppRoutes.buildPathWithQuery(
        [AppRoutes.DASHBOARD_EXECUTION_PATH, executionConfig.battlecards.link, id],
        query,
        {
            encode: true,
        },
    );
};
